import React from "react";

import { CourseDocumentForm, DocumentFormValues } from "./CourseDocumentForm";
import { courseDocumentsApi } from "api";
import { useToaster } from "utils";
import { useCourseDocument } from "api/hooks";
import { PaziaLoader } from "components/atoms";

interface CourseDocumentEditProps {
  courseId: number;
  courseDocumentId: number;
}

export const CourseDocumentEdit = ({ courseId, courseDocumentId }: CourseDocumentEditProps) => {
  const { showSuccess, showError } = useToaster();
  const { data: apiDocument, loading } = useCourseDocument(courseId, courseDocumentId);

  const onSubmit = async (data: DocumentFormValues) => {
    const { templateId, name, activePage, ...formData } = data;
    const placeholders = Object.entries(formData).map(([key, value]) => ({
      placeholderId: Number(key),
      placeholderValue: value + "",
    }));

    try {
      if (!activePage) {
        throw new Error("Brak aktywnej strony szablonu");
      }
      await courseDocumentsApi.update(courseId, courseDocumentId, {
        templateId: Number(templateId),
        templatePageId: Number(activePage),
        placeholders,
        name,
      });
      showSuccess("Zaktualizowano dokument");
    } catch (e) {
      showError("Nie udało się zaaktualizować dokumentu");
      console.error(e);
    }
  };

  if (loading) return <PaziaLoader position="center" />;
  if (!apiDocument) return null;

  return <CourseDocumentForm onSubmit={onSubmit} courseId={courseId} document={apiDocument} />;
};
